/* ══════════════════════════════════════════════════════════════════════════
   ONIX — L'OFFRE DANS L'EN-TÊTE : alternance « Offre découverte » et paliers, centrage à l'œil.

   ⛔ 24/10 — NOUVEL AFFICHAGE, VALIDÉ PAR BRAMS (10h59 et 11h41). Le texte souligné
   de cyan, le prix qui clignote et la flèche « clique ici » sont RETIRÉS (« le
   design est moche », 10h16). À la place, « le prix et sa pastille », d'après la
   barre d'achat d'Apple : un petit bouton enchâssé dans la barre, une pastille
   chromée (la matière du logo) au-dessus du prix en blanc — forme dans
   onix-offre.css. Et l'alternance commence par le NOM de l'offre, ses mots (11h41) :
   « Si le client découvre seulement en ouvrant la pop-up que c'est une offre
   découverte, ça crée de la friction […] juste une transition, “2 maillots
   29,99 €”, puis le simple mot “Offre découverte” ». Maquette, références et
   mesures : livrables/2026-10-24-offre-decouverte-finale/.

   Mise au propre des décisions du 12/08 prises dans la planche d'essai
   (assets/onix-planche.js), qui porte les variantes écartées et le raisonnement.
   La planche ne se charge JAMAIS en production.

   ⚠️ POURQUOI DU JS ET PAS DU LIQUID. Trois choses ne peuvent pas se calculer au
   rendu :
     · les MONTANTS, qui doivent être CONVERTIS dans la devise du visiteur :
       Liquid ne sait pas convertir un littéral, seul `Shopify.currency.rate`
       le peut (ils sont lus dans la pop-up, pas dans le texte de la page — voir
       `paliers()` plus bas) ;
     · le CENTRAGE, qui dépend de la largeur du vide autour de l'offre, et donc
       du voisin de droite : le panier sur mobile, « Contactez-nous » sur
       ordinateur (121 px contre 320 px mesurés) ;
     · le compteur de FAVORIS, qui vit dans le navigateur du client.
   Tout le reste est en Liquid et en CSS — Y COMPRIS LE RENDU LUI-MÊME depuis le
     05/09 : header.liquid émet déjà `.onix-offre__l` avec son palier, ce fichier
     ne fait que l'ENRICHIR. Il n'existe plus de « version de repli ».
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* 3,5 s par ligne, fondu de 0,7 s (onix-offre.css) : « transitions douces et
     lentes, assez pour lire » — 24/10. Trois lignes : un tour complet en 10,5 s. */
  var PERIODE = 3500;   // durée d'affichage d'une ligne, en ms
  var minuteur = null;

  /* ── LES PALIERS : LA SOURCE DE VÉRITÉ, PLUS JAMAIS LE TEXTE DE LA PAGE ──
     ⛔ AVANT LE 05/09 LES PRIX ÉTAIENT RACLÉS DANS LA PAGE : on parcourait tous
     les nœuds feuilles du <body> et on retenait le premier montant qui collait
     à /^29[.,]/ puis à /^4[45][.,]/. Deux façons de mentir, les deux mesurées :
       · le comparateur d'accueil affiche un prix CONCURRENT barré
         (<s class="onix-t3cmp__barre">29,99 €</s>). Selon l'ordre du DOM,
         l'en-tête pouvait annoncer le prix d'un concurrent comme étant le nôtre ;
       · le jour où le vrai prix de l'offre ne commence plus par 29, plus aucun
         montant ne sort — une panne silencieuse déclenchée par un changement de
         tarif, sans une ligne de code touchée.

     ➢ ON LIT LES BOUTONS DE PALIER DE LA POP-UP : `#onix-offer [data-offer-tier]`,
       `data-tier-max` (le nombre de maillots) et `data-tier-cents` (le prix EN
       CENTIMES D'EUROS). Ce sont EXACTEMENT les deux valeurs que `selectTier()`
       (sections/header.liquid) lit pour construire le panier et choisir le code
       de remise. Si l'en-tête et la pop-up divergeaient, c'est l'en-tête qui
       mentirait sur ce qu'on va faire payer : ici les deux ne PEUVENT pas
       diverger, elles lisent le même attribut.
     ⚠️ ON LIT L'ATTRIBUT, PAS LE TEXTE DU BOUTON DE PALIER. Hors zone euro la
       pop-up réécrit ce texte en « −40 % » / « −55 % » (`priceDisplay`,
       header.liquid) : le texte n'y est donc plus un prix, l'attribut si.
     ⚠️ ON NE FIGE AUCUN MONTANT ICI. Le palier 1 vient du réglage marchand
       `offer_price`, le palier 2 de la pop-up. Une valeur en dur dans ce fichier
       redeviendrait fausse au premier changement de tarif, sans rien signaler. */
  function paliers() {
    var out = [];
    var pastilles = document.querySelectorAll('#onix-offer [data-offer-tier]');
    for (var i = 0; i < pastilles.length; i++) {
      var n = parseInt(pastilles[i].getAttribute('data-tier-max'), 10);
      var c = parseInt(pastilles[i].getAttribute('data-tier-cents'), 10);
      if (!isFinite(n) || n <= 0) continue;
      out.push({ n: n, cents: (isFinite(c) && c > 0) ? c : null });
    }
    return out;
  }

  /* ── LE NOM DE L'OFFRE, LU DANS LA POP-UP — 24/10 ─────────────────────────
     Même principe que les prix : une seule source. Le titre de la pop-up vient du
     réglage marchand `offer_title` (traduit par onix-ts hors français) ; l'en-tête
     le relit au lieu de l'écrire une deuxième fois. Le premier mot va dans la
     pastille, le reste dessous : « OFFRE » / « Découverte ».
     Repli : le défaut du Liquid lui-même, 'Offre Découverte'. */
  function titre() {
    var h = document.querySelector('#onix-offer .onix-offer__title');
    var t = ((h && h.textContent) || '').replace(/\s+/g, ' ').trim() || 'Offre Découverte';
    var i = t.indexOf(' ');
    if (i > 0) return { n: t.slice(0, i), p: t.slice(i + 1) };
    /* Un seul mot composé (« Entdecker-Angebot », de.json) : coupé au trait d'union,
       sinon il ferait toute la largeur du bouton sur une seule ligne. */
    var u = t.indexOf('-');
    if (u > 0 && u < t.length - 1) return { n: t.slice(0, u), p: t.slice(u + 1) };
    return { n: t, p: null };
  }

  /* Largeur propre d'une ligne : celle de son texte le plus large (la ligne, elle,
     prend la largeur de la case commune, donc celle de la plus large des trois). */
  function largeurLigne(l) {
    var w = 0;
    for (var i = 0; i < l.children.length; i++) w = Math.max(w, l.children[i].getBoundingClientRect().width);
    return w;
  }

  /* ⛔ LE NOM DE L'OFFRE N'ÉLARGIT JAMAIS LE BOUTON — 24/10, trouvé à l'attaque
     (angles 5 et 7). Le titre vient d'un réglage TRADUIT : « Kennismakingsaanbod »
     (nl.json), « oferta descubrimiento » (es.json) sont bien plus larges que
     « 2 MAILLOTS ». Les lignes étant empilées, la plus large fixe la largeur du
     bouton : il recouvrait le panier et le logo (−21 px à 360 px en néerlandais).
     On réduit donc la ligne du nom (els[0]) jusqu'à la largeur des lignes de prix,
     plancher 9 px ; rend false si elle ne tient pas même au plancher. Réduction en
     `em` : elle suit `--onix-corps` quand centrer() réduit tout le bouton. */
  function ajusterNom(els) {
    if (els.length < 2) return true;
    var nom = els[0], ref = 0;
    for (var i = 1; i < els.length; i++) ref = Math.max(ref, largeurLigne(els[i]));
    var w = largeurLigne(nom);
    if (!ref || w <= ref + 0.5) return true;
    var corps = parseFloat(getComputedStyle(nom.parentNode).fontSize) || 13;
    nom.style.fontSize = Math.max(9 / corps, ref / w).toFixed(3) + 'em';
    return largeurLigne(nom) <= ref + 0.5;
  }

  /* ── LE PRIX, DANS LA DEVISE DU VISITEUR ──────────────────────────────────
     Même patron que le reste du thème (assets/cart-drawer-suggest.js,
     sections/onix-home-top3.liquid) : une référence en CENTIMES D'EUROS,
     convertie par `Shopify.currency.rate`.
     ⚠️ `{{ … | money }}` FORMATE SANS CONVERTIR — mesuré le 04/09 : un visiteur
       suisse lisait « CHF 29.99 » là où la conversion donne CHF 28.75. C'est
       pour ça que le prix ne peut pas être écrit en Liquid hors euro.
     ⚠️ L'ARRONDI À L'UNITÉ N'EST PAS UN DÉFAUT, et j'ai failli le « corriger » :
       les vrais prix produits rendent CHF 24.00 pour 24,99 € — c'est la règle
       d'arrondi du marché Shopify. On la reproduit pour que l'en-tête, les
       fiches et le comparateur disent la même chose.
     ⛔ UN TAUX MANQUANT HORS EURO NE VAUT PAS 1. `parseFloat(x) || 1` ferait
       réapparaître le montant en euros sur une page en francs — le défaut même
       qu'on corrige, ressuscité par son propre repli. On dégrade vers RIEN.
       En euro le taux vaut 1 par définition, son absence y est inoffensive. */
  function devise() {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var taux = parseFloat(((window.Shopify || {}).currency || {}).rate);
    if (!isFinite(taux) || taux <= 0) taux = (cur === 'EUR') ? 1 : NaN;
    return { cur: cur, taux: taux };
  }

  function montant(centsEur, dev) {
    if (!isFinite(centsEur) || centsEur <= 0 || !isFinite(dev.taux)) return null;
    if (dev.cur === 'EUR') return (centsEur / 100).toFixed(2).replace('.', ',') + ' €';
    var v = Math.round(centsEur * dev.taux / 100);
    if (!isFinite(v) || v <= 0) return null;
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: dev.cur,
        currencyDisplay: 'narrowSymbol' }).format(v);
    } catch (e) { return v.toFixed(2) + ' ' + dev.cur; }
  }

  /* Une ligne de palier. ⚠️ On construit par nœuds, pas par innerHTML : le nom du
     palier vient d'une CHAÎNE DE TRADUCTION (`offer.items`), donc d'un fichier
     qu'on édite — `textContent` échappe, une concaténation non.
     ⚠️ PAS DE <em> QUAND IL N'Y A PAS DE PRIX. Un <em> vide laisserait un
     soulignement cyan de 0 px et son animation ; surtout, la règle est qu'on
     n'affiche PAS un prix faux — alors on n'en affiche aucun. */
  function ligne(x) {
    var l = document.createElement('span');
    l.className = 'onix-offre__l' + (x.p ? '' : ' onix-offre__l--nu');
    var b = document.createElement('b');
    b.textContent = x.n;
    l.appendChild(b);
    if (x.p) {
      var em = document.createElement('em');
      em.textContent = x.p;
      l.appendChild(em);
    }
    return l;
  }

  /* ⛔ CETTE FONCTION N'A PLUS DE REPLI — 05/09, sa décision : « que celle-là,
     j'ai jamais demandé deux versions ». Avant, elle rendait `false` dès que la
     devise n'était pas EUR ou qu'un montant manquait, et le markup Liquid
     d'origine restait à l'écran : la pastille « OFFRE / découverte ». Ce n'était
     pas un flash, c'était le rendu DÉFINITIF de tout visiteur hors zone euro
     (mesuré en ligne en GBP, 3 pages sur 3). Le markup de la pastille est
     supprimé : header.liquid rend désormais DÉJÀ `.onix-offre__l`, et cette
     fonction ne fait que l'ENRICHIR (2ᵉ palier, alternance, devise convertie).
     ⚠️ Elle ne doit donc plus jamais VIDER le bouton sans le remplir : on ne
     touche au markup qu'une fois les paliers lus. */
  function construire() {
    var btn = document.querySelector('.header__offer-btn');
    var cellule = document.querySelector('.header__title');
    if (!btn || !cellule) return false;

    /* ⚠️ L'OFFRE EST ANCRÉE AU LOGO, MAIS HORS FLUX. Placée dans le flux de la
       cellule du titre, elle l'élargissait de 35 à 182 px et POUSSAIT le logo de
       73 px hors du centre — « le logo doit rester centré », 12/08. En absolu,
       elle ne pèse plus dans la grille de l'en-tête. */
    if (!cellule.contains(btn)) cellule.appendChild(btn);
    cellule.classList.add('onix-titre-offre');

    if (btn.dataset.onixPret === '1') return true;   // déjà enrichi

    var liste = paliers();
    /* La pop-up n'est pas rendue (offre coupée, ou markup manquant) : on GARDE le
       squelette Liquid tel quel. Il porte déjà le bon palier, et son prix si la
       page est en euro. Rien à remplacer, surtout pas par une pastille. */
    if (!liste.length) return false;

    var dev = devise();
    var items = btn.dataset.onixItems || 'maillots';
    var lignes = [titre()].concat(liste.map(function (x) {
      return { n: x.n + ' ' + items, p: montant(x.cents, dev) };
    }));

    /* Le texte ne change jamais EN PLACE, il PASSE EN FONDU : une substitution
       sèche se lit comme un clignotement et fait sauter l'œil hors de la barre.
       ⚠️ 24/10 — LES LIGNES SONT EMPILÉES AU MÊME ENDROIT (grille, onix-offre.css),
       plus une piste qui défile : le bouton prend d'office la largeur de la ligne
       la plus large, il ne change jamais de taille d'une ligne à l'autre, et le
       centrage calculé une fois reste juste pour les trois. */
    var fen = document.createElement('span');
    fen.className = 'onix-offre__fen';
    var piste = document.createElement('span');
    piste.className = 'onix-offre__piste';
    var els = lignes.map(function (x) { var l = ligne(x); piste.appendChild(l); return l; });
    els[0].classList.add('onix-offre__l--nom');     // le nom de l'offre, un cran plus petit (CSS)
    fen.appendChild(piste);
    btn.textContent = '';
    btn.appendChild(fen);
    btn.dataset.onixPret = '1';
    btn.classList.add('onix-offre--tourne');
    /* Trop long même réduit : le nom ne s'affiche pas — mieux vaut deux lignes de
       prix qu'un bouton qui vole la place du panier (voir ajusterNom). */
    if (!ajusterNom(els)) { piste.removeChild(els[0]); els.shift(); }
    els[0].classList.add('is-on');

    if (minuteur) { clearInterval(minuteur); minuteur = null; }
    if (els.length < 2) return true;                // une seule ligne : rien à faire tourner
    /* ⛔ LE TÉLÉPHONE DEMANDE MOINS DE MOUVEMENT : RIEN NE TOURNE. La première
       ligne reste, le nom de l'offre : c'est lui qui évite le malentendu (« deux
       maillots pour 29,99 €, peu importe la sélection », 24/10) ; les prix sont
       dans la pop-up. */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;

    var k = 0;
    minuteur = setInterval(function () {
      var avant = els[k];
      k = (k + 1) % els.length;
      avant.classList.remove('is-on');
      avant.classList.add('is-out');                // la sortante monte en s'effaçant
      els[k].classList.remove('is-out');
      els[k].classList.add('is-on');                // l'entrante arrive d'en dessous
      setTimeout(function () { avant.classList.remove('is-out'); }, 800);
    }, PERIODE);
    return true;
  }

  /* ── Centrer l'offre dans le vide qui l'entoure ───────────────────────────
     « je veux que le bouton soit centré entre les 2 boutons qui l'entourent, en
     mode la même largeur de chaque côté » — 12/08.

     ⚠️ LE CSS SEUL NE PEUT PAS. La marge devrait valoir la moitié du vide
     restant, et ce vide dépend de l'écran parce que le VOISIN DE DROITE change :
     le panier sur mobile (à 326 sur un écran de 375), « Contactez-nous » sur
     ordinateur (à 981 sur 1280). Mesuré : 121 px de vide d'un côté, 320 de
     l'autre. Toute valeur figée est fausse sur l'un des deux.
     ⚠️ Le voisin se trouve par les RECTANGLES, pas par une liste de sélecteurs
     en dur : le thème change ses icônes d'en-tête, une liste vieillirait en
     silence et le centrage redeviendrait faux sans que rien ne le dise. */
  /* Bord gauche VISIBLE d'un bouton d'en-tête : le tracé de son icône s'il en a
     une, plus la moitié du trait (qui déborde du tracé) ; sinon sa boîte. */
  function bordVisible(e, r) {
    var traces = e.querySelectorAll('svg path');
    var g = Infinity;
    for (var i = 0; i < traces.length; i++) {
      var p = traces[i], svg = p.ownerSVGElement, b = p.getBoundingClientRect();
      if (!svg || b.width === 0) continue;
      var vb = svg.viewBox && svg.viewBox.baseVal;
      var ech = (vb && vb.width) ? svg.getBoundingClientRect().width / vb.width : 1;
      var trait = parseFloat(p.getAttribute('stroke-width') || svg.getAttribute('stroke-width')) || 0;
      g = Math.min(g, b.left - trait * ech / 2);
    }
    return isFinite(g) ? g : r.left;
  }

  function centrer() {
    var btn = document.querySelector('.header__offer-btn');
    var cel = document.querySelector('.header__title');
    var head = btn && btn.closest('.site-header');
    if (!btn || !cel || !head) return;

    /* ⛔ 24/10 — CENTRÉ SUR CE QUE L'ŒIL VOIT, PLUS SUR LES BOÎTES. Brams, 10h59, sur
       une offre centrée de boîte à boîte : « elle n'est pas centrée entre le logo
       et le panier, elle est attirée vers le logo ». Mesuré sur la capture : l'image
       du logo est carrée et porte 5,48 % de vide transparent à droite, et la boîte
       du bouton panier commence environ 7 px avant le sac dessiné. Centrer entre
       les boîtes décalait l'offre de 2 à 5 px vers le logo. On centre donc entre le
       bord VISIBLE du logo et le bord VISIBLE de l'icône voisine. Mesuré ensuite :
       même air à gauche et à droite, à 0,1 px près, à 360, 390 et 430 px.
       ⚠️ VIDE_LOGO est propre à l'image du logo actuelle (ChatGPT_New_logo_noir.png).
       Si le logo change, remesurer (outils/verifier.mjs de la maquette) : sinon
       l'écart revient, de 1 à 2 px, sans rien casser d'autre. */
    var VIDE_LOGO = 0.0548;
    var img = cel.querySelector('img');
    var rl = (img || cel).getBoundingClientRect();
    var bordLogo = rl.right - (img ? rl.width * VIDE_LOGO : 0);
    var voisin = null, voisinVu = null;   // boîte du voisin (zone tactile) et bord visible de son icône
    Array.prototype.forEach.call(head.querySelectorAll('a,button,summary'), function (e) {
      if (e === btn || btn.contains(e) || e.contains(btn)) return;
      var r = e.getBoundingClientRect();
      if (r.width < 12 || r.height < 12) return;
      if (r.left < bordLogo - 1) return;
      if (voisin === null || r.left < voisin) { voisin = r.left; voisinVu = bordVisible(e, r); }
    });
    if (voisin === null) { btn.style.left = 'calc(100% + 8px)'; return; }

    /* —— QU'ELLE TIENNE DANS LE VIDE, EN DEUX LEVIERS — 05/09 ———————————
       `Math.max(4, …)` plus bas ne POSE qu'un plancher à la marge : il ne retient
       rien. Quand l'offre est plus large que le vide, elle déborde quand même et
       passe SOUS le bouton panier — c'est-à-dire derrière, puisque le panier est
       peint après : texte illisible ET cible tactile volée, la famille du badge
       de favoris du 23/08. Ce n'était pas visible tant que le prix tenait en
       « 29,99 € » ; hors zone euro il devient « CHF 29.00 », +16 % de largeur.

       ⚠️ ON NE DEVINE NI LA DEVISE NI LA LANGUE. « SEK 320.00 » est plus long
         encore, et `offer.items` se traduit. On MESURE ce qui est peint.
       ⚠️ ON REPART TOUJOURS DE L'ÉTAT NOMINAL — corps ET serrage. Sans ces deux
         remises à zéro, chaque redimensionnement réduirait à partir du résultat
         précédent : l'offre rétrécirait à chaque rotation d'écran sans repousser.

       LEVIER 1 — LE CORPS, plancher à 9 px, boucle bornée à 6 tours qui s'arrête
       dès que la largeur ne bouge plus : une ligne `white-space:nowrap` peut
       cesser de rétrécir (espaces, lettrage), et une boucle qui attend un seuil
       qu'elle n'atteindra jamais fige l'onglet.
       LEVIER 2 — LE SERRAGE (`onix-offre--serre`), quand le plancher est atteint
       et que ça ne tient toujours pas. Il ne retire AUCUN mot : il rend l'espace
       entre le libellé et le prix, l'interlettrage du libellé et son corps
       relatif.

       AVANT / APRÈS, mesuré au banc — jeu entre le bouton de l'offre et le bouton
       panier, négatif = recouvrement. Logo réel de 35,2 px, cinq devises :
         320 px CHF   −17,7 px  →  +0,0 px de boîte à boîte, +2,6 px de glyphe
         320 px EUR    −5,7 px  →  +7,6 px
         320 px SEK    −0,6 px  →  +4,7 px
         360 px CHF    +2,3 px  →  +2,3 px — rien à faire, `--serre` ne part pas
         390 / 430 px            inchangés, `--serre` ne s'y déclenche pas

       ⛔ CE QUI L'A FAIT PASSER DE −17,7 À 0, ET QU'IL NE FAUT PAS DÉFAIRE.
         « CHF 29.00 » à 320 px est le libellé le plus large de la boutique, et il
         tient à 0,0 px près. Desserrer l'un des quatre réglages de `--serre`,
         remonter le plancher de 9 px ou allonger le libellé le fait recouvrir
         de nouveau — le vérifier au banc, pas à l'œil : 2,6 px ne se voient pas.
       ⛔ 24/10 — CES CHIFFRES SONT CEUX DE L'ANCIEN AFFICHAGE (une seule ligne). Remesuré
         sur « le prix et sa pastille » (trois lignes empilées), jeu de BOÎTE à BOÎTE
         avec le bouton panier, après la borne tactile (voir plus bas) :
           320 px EUR +2,0 px · CHF +2,0 · XOF +2,0 (la borne joue, le corps descend)
           360 px EUR +6,6 · espagnol +3,5 · néerlandais (nom retiré) +6,5
           390 px +14,1 · 430 px +24,1 · ordinateur 1440 px : air identique à 0,5 px
         Bancs : livrables/2026-10-24-offre-decouverte-finale/outils/verifier-essai.mjs
         et les deux preuves d'attaque rangées dans outils/attaque/ du même dossier.
       ⚠️ ET SI UN JOUR ÇA NE SUFFIT PLUS — devise plus longue, langue plus
         longue — la suite n'est PAS de rapetisser encore : sous 9 px on ne lit
         plus. C'est de RETIRER quelque chose (le libellé, le prix, ou les deux
         décimales que le reste de la boutique écrit), donc une décision de
         contenu, qui se demande. Ne pas la prendre ici en silence.
       ⚠️ NE PAS RÉÉCRIRE CE COMMENTAIRE EN « ça tient partout » SANS REMESURER.
         La version du 05/09 au matin affirmait déjà « elle ne franchit plus son
         voisin » pendant que la mesure disait −17,7 px. */
    var ligneRef = btn.querySelector('.onix-offre__fen') || btn.querySelector('.onix-offre__l');   // le corps, pas celui du nom réduit
    btn.style.removeProperty('--onix-corps');
    btn.classList.remove('onix-offre--serre');
    var place = voisin - rl.right - 8;          // de boîte à boîte, 4 px de respiration de chaque côté
    var large = btn.getBoundingClientRect().width;
    if (ligneRef && place > 24 && large > place) {
      var corps = parseFloat(getComputedStyle(ligneRef).fontSize) || 12;
      for (var t = 0; t < 6 && large > place; t++) {
        corps = Math.max(9, corps * Math.max(0.8, place / large));
        btn.style.setProperty('--onix-corps', corps.toFixed(2) + 'px');
        var apres = btn.getBoundingClientRect().width;
        if (apres >= large - 0.5) break;        // ça ne rétrécit plus : on s'arrête
        large = apres;
        if (corps <= 9) break;
      }
      /* ⚠️ LE SERRAGE SE DÉCLENCHE SUR UNE COLLISION, PAS SUR `place`. `place`
         retranche 8 px de confort ; s'en servir de seuil faisait serrer à 390 px
         — la largeur de référence — pour 0,03 px de dépassement dû à l'arrondi
         de la boucle, et le libellé tombait à la moitié de son corps sans raison
         visible. Le seuil, c'est le vide RÉEL moins 2 px de garde. */
      if (large > (voisin - rl.right - 2)) {
        btn.classList.add('onix-offre--serre');
        large = btn.getBoundingClientRect().width;
      }
    }

    /* ⛔ LA MARGE NE POUSSE PLUS L'OFFRE SUR SON VOISIN. `Math.max(4, …)` posait
       un plancher de 4 px SANS regarder ce qui restait : quand le vide valait
       3,7 px, il en réclamait 4 et faisait franchir le bouton panier — mesuré,
       la marge elle-même créait le recouvrement qu'on venait de réduire.
       On centre tant qu'il y a de quoi (8 px), on prend ce qui reste sinon. */
    /* Position : centrée À L'ŒIL entre le bord visible du logo et celui de l'icône
       voisine (air identique à 0,1 px près à 360, 390 et 430 px en français)… */
    var x = bordLogo + (voisinVu - bordLogo - large) / 2;
    /* ⛔ …MAIS JAMAIS SUR UNE ZONE TACTILE — 24/10, trouvé à l'attaque (angles 5 et 7).
       La boîte du bouton panier commence ~7 px avant le sac dessiné : centrée sur le
       dessin seul, l'offre passait 2,5 px SOUS la boîte du panier à 320 px (euro,
       CHF, XOF) et à 360 px en espagnol — le bord droit de l'offre ouvrait le panier.
       On borne donc par les BOÎTES, 2 px de garde de chaque côté. Quand la borne
       joue, l'œil perd un peu de centrage ; le doigt, lui, ne se trompe plus.
       ⚠️ `left` se compte depuis le bord droit de la CELLULE du titre (100 %). */
    var xMax = voisin - 2 - large, xMin = rl.right + 2;
    if (x > xMax) x = xMax;
    if (x < xMin) x = Math.min(xMin, Math.max(xMax, rl.right));
    btn.style.left = 'calc(100% + ' + (x - cel.getBoundingClientRect().right).toFixed(2) + 'px)';
  }

  /* ⛔ L'APPEL DESSINÉ (« clique ici » et sa flèche) EST RETIRÉ — 24/10. Il faisait
     partie de l'affichage que Brams a rejeté (« le design est moche ») ; la
     version validée n'en a pas. Sa forme est retirée d'onix-offre.css. */

  /* ── Les favoris n'apparaissent que s'il y en a ───────────────────────────
     ⚠️ Le compte vit dans le navigateur du client, donc Liquid ne peut pas le
     connaître au rendu : le bouton part masqué et on le révèle. Partir visible
     puis masquer ferait clignoter l'en-tête à chaque chargement. On suit le
     compteur du thème plutôt que de relire le stockage nous-mêmes — sinon deux
     sources de vérité pour un même nombre. */
  function favoris() {
    var lien = document.querySelector('.header__fav-link');
    var compteur = document.querySelector('[data-fav-count]');
    if (!lien || !compteur) return;
    var maj = function () {
      var n = parseInt(compteur.textContent, 10) || 0;
      lien.style.display = n > 0 ? '' : 'none';
    };
    maj();
    new MutationObserver(maj).observe(compteur,
      { childList: true, characterData: true, subtree: true, attributes: true });
  }

  /* ── Révéler l'offre, une fois qu'elle est posée ──────────────────────────
     ⚠️ ELLE PART INVISIBLE — 14/08, « je vois l'ancien bouton de l'offre
     découverte apparaître très rapidement à gauche du logo puis redisparaître ».
     Le bouton est maintenant rendu en Liquid dans `.header__title`, donc au bon
     endroit dès le premier rendu, mais il lui reste son contenu à recevoir et sa
     marge à calculer. Il porte `onix-offre--attente` (visibility:hidden) jusqu'ici.

     ⚠️ CETTE FONCTION DOIT ÊTRE APPELÉE SUR TOUS LES CHEMINS, y compris le repli
     hors zone euro où le libellé du thème reste tel quel. Une offre laissée
     invisible, c'est le bouton d'achat en moins — la panne serait silencieuse et
     ne se verrait sur aucune capture. */
  function reveler() {
    var btn = document.querySelector('.header__offer-btn');
    if (btn) btn.classList.remove('onix-offre--attente');
  }

  /* ⛔ PLUS DE BRANCHE « REPLI » — 05/09. Elle sautait `centrer()` et `appel()`
     quand `construire()` échouait : hors zone euro, l'offre restait donc collée
     au logo à `left:calc(100% + 8px)`, sans même le centrage. Aujourd'hui il n'y
     a plus qu'un chemin — le squelette Liquid est déjà le bon rendu, `construire()`
     ne fait que l'enrichir — donc les étapes se font toujours, dans cet ordre
     (l'appel dessiné en moins depuis le 24/10). `reveler()` reste EN DERNIER : rien
     ne bouge plus quand l'offre apparaît. */
  function tout() {
    construire();
    centrer();
    reveler();                   // EN DERNIER : rien ne bouge plus quand elle apparaît
  }

  var attente = null;
  window.addEventListener('resize', function () {
    clearTimeout(attente);
    attente = setTimeout(centrer, 120);
  });

  /* ⚠️ LE FILET N'EST PAS ICI, IL EST EN LIGNE DANS header.liquid, juste après le
     bouton. Posé dans ce fichier, il ne couvrirait pas le cas qui compte : si
     `onix-offre.js` ne se charge pas — 404, coupure CDN — le filet ne se
     chargerait pas non plus et l'offre resterait invisible pour toujours. Un
     script en ligne, lui, part avec le HTML. Ne pas le rapatrier ici. */

  function demarrer() { tout(); favoris(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();

  /* ⚠️ LA CONDITION DE RATTRAPAGE A CHANGÉ AVEC LA SOURCE DES PRIX. Elle testait
     `.onix-offre__l` — or cette classe est maintenant rendue par header.liquid,
     donc elle est TOUJOURS là et le rattrapage ne se serait plus jamais déclenché.
     On teste ce qu'on veut vraiment savoir : le bouton a-t-il été ENRICHI ?
     `data-onix-pret` n'est posé que quand les paliers ont été lus. */
  window.addEventListener('load', function () {
    var btn = document.querySelector('.header__offer-btn');
    if (btn && btn.dataset.onixPret !== '1') tout();
  });

  /* ⚠️ LES GRAISSES 500/600 PEUVENT ARRIVER APRÈS LE PREMIER CALCUL (font-display:
     swap, chargées seulement quand un texte les emploie) : la largeur du bouton
     bouge alors de 1 à 3 px et le centrage à l'œil se perd. On recale à chaque
     police chargée : le nom est réajusté, puis l'offre recentrée. */
  if (document.fonts && document.fonts.addEventListener) {
    document.fonts.addEventListener('loadingdone', function () {
      var nom = document.querySelector('.header__offer-btn .onix-offre__l--nom');
      if (nom) { nom.style.fontSize = ''; ajusterNom([].slice.call(nom.parentNode.children)); }
      centrer();
    });
  }
})();
